import { SearchParkablesQueryVariables } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  identifier?: SearchParkablesQueryVariables[`identifier`] | null | undefined;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class ParkableNotFound extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { identifier, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.PARKABLE_TRANSACTIONS,
      type: `PARKABLE_NOT_FOUND`,
      data: {
        identifier,
      },
    });
  }
}

export { ParkableNotFound };
